import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import api from "../../services/Api";
import { api as ApiURl } from "../../services/ApiURL";
import { getDate, getNameMonth } from "../../utils/dateTimeHelper";
import { formatCurrency, formatIntegerToMoney, formatToFloat } from "../../utils/formatCurrency";
import { Tooltip, BarChart, Bar, Pie, LineChart, Line, AreaChart, Area, PieChart, Cell } from "recharts";
import { Grid, MenuItem, Switch, TextField, Typography, Tooltip as TooltipMaterialUi, RadioGroup, FormControlLabel, Radio, makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { Autocomplete, Pagination } from "@material-ui/lab";
import useCompany from "../../hooks/company";
import { Spinner } from "react-bootstrap";
import { Calendar } from './Calendar';
import { PdvSale } from "../../types/PdvSale";
import { PdvSalePayment } from "../../types/PdvSalePayment";
import { useCompanyBranch } from "../../hooks/companyBranch";
import useCurrentBalance from "../../hooks/useCurrentBalance";
import CashFlowService from "../../services/CashFlowService";
import { totalAccounts } from "../../components/BankAccountsTotalsPieChart";
import { cashFlow, CashFlowComposedChart } from "../../components/CashFlowComposedChart";
import { MainPageContentWrapper } from "../../components/MainPageContentWrapper";
import useMenu from "../../hooks/menu";
import { BankButton } from "../../components/BankButton";
import { formatDate } from "../../utils/dateFormat";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

type sells = {
  name: string,
  vendas: number,
}

type invoicing = {
  id: number,
  name: string,
  value: number
}

type menuSystem = {
  id: number,
  name: string,
  route: string,
  visible: string,
  menuId: number,
  order: number
}

type pdv = {
    id: number,
    active: string,
    userId: number,
    operator: string,
    companyId: string,
    createdDate: string,
    openedDate: string,
    startValue: number,
    currentValue: number,
    limitValue: number,
    totalCashier: number,

    alert: boolean;
    companyName: string;
}

type ranking = {
  id: number,
  name: string,
  value: number,
}

type LatestBudgets = {
  id: number,
  customer: string,
  date: string,
  totalValue: number
}

type CompanyGrowthPercentage = {
  month: string,
  percentage: number
}

const medalColor: { [index: number]: string } = {
  0: "#FFD700",
  1: "#C0C0C0",
  2: "#CE8946"
}

const fakeCustomerData = [
  {
    quantity: 4,
  },
  {
    quantity: 5,
  },
  {
    quantity: 7,
  },
  {
    quantity: 9,
  },
];

const fakeRequestData = [
  {
    quantity: 6,
  },
  {
    quantity: 7,
  },
  {
    quantity: 9,
  },
  {
    quantity: 3,
  },
];

const fakeServiceOrderData = [
  {
    quantity: 12,
  },
  {
    quantity: 8,
  },
  {
    quantity: 10,
  },
  {
    quantity: 9,
  },
];

const fakePurchaseOrderData = [
  {
    quantity: 16,
  },
  {
    quantity: 10,
  },
  {
    quantity: 10,
  },
  {
    quantity: 7,
  },
];

const useStyles = makeStyles({
  radioGroup: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px",
  },
  radio: {
    display: "none"
  },
  label: {
    color: "#000",
    padding: "6px 8px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: 'background-color 0.3s ease, color 0.3s ease',
    '&.Mui-checked': {
      backgroundColor: "#181c32",
      color: "#fff",
    },
  },
  selectedLabel: {
    backgroundColor: "#181c32",
    color: "#fff",
  },
})

export function DashboardPage() {
  const divRef = useRef<HTMLDivElement>(null);
  
  const classes = useStyles();

  const { user } = useSelector((state: any) => state.auth);
  const { menus } = useMenu();
  const [companyplan, setCompanyPlan] = useState<any>();
  const {mainAndBranches} = useCompany({ mainCompanyId: user.companyId});
  const { selectedCompany: currentCompany } = useCompanyBranch();

  // Data da Dashboard
  const [typeShowDashboard, setTypeShowDashboard] = useState("month");
  const [monthDashboard, setMonthDashboard] = useState(new Date().getMonth() + 1);
  const [yearsAvailable, setYearsAvailable] = useState<Number[]>([]);
  const [yearDashboard, setYearDashboard] = useState(new Date().getFullYear());
  const [companyDashboard, setCompanyDashboard] = useState("0");

  // Saldo Total Por Conta
  const [totalAccounts, setTotalAccounts] = useState<totalAccounts[]>([]);
  const { totalBalance, getTotalBalance } = useCurrentBalance(companyDashboard);

  // Fluxo de Caixa
  const [cashFlow, setCashFlow] = useState<cashFlow[]>([]);
  const [cashReceive, setCashReceive] = useState(0);
  const [cashPay, setCashPay] = useState(0);
  const [typeShow, setTypeShow] = useState("accomplished");

  // Calendário de Lançamentos e Eventos
  const [dateSelected, setDateSelected] = useState(getDate({ initialDate: new Date}).dateStr);

  // Faturamento por Cliente
  const [billingPerCustomers, setBillingPerCustomers] = useState<invoicing[]>([]);

  // Dados dos cards do topo do dashboard
  const [customersQuantity, setCustomersQuantity] = useState<number>();
  const [requestsQuantity, setRequestsQuantity] = useState<number>();
  const [serviceOrdersQuantity, setServiceOrdersQuantity] = useState<number>();
  const [purchaseOrdersQuantity, setPurchaseOrdersQuantity] = useState<number>();

  // Dados do card de últimos orçamentos
  const [latestBudgets, setLatestBudgets] = useState<LatestBudgets[]>();

  // Dados do card de saldos bancários
  const [bank, setBank] = useState<string>("Bradesco");
  const [filteredBanks, setFilteredBanks] = useState<totalAccounts[]>();

  // Logo da empresa selecionada
  const [logo, setLogo] = useState<string>("");

  // Estados da paginação dos saldos bancários
  const [page, setPage] = useState<number>(1);
  const [pageCount, setPageCount] = useState<number>(1);

  // Dados de crescimento da empresa
  const [companyGrowth, setCompanyGrowth] = useState<cashFlow[]>();

  const AntSwitch = withStyles((theme: any) => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      '&$checked': {
        transform: 'translateX(12px)',
        color: theme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none',
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }))(Switch);

  const getSubscriptionPlan = useCallback(async () => {
      const response = await api.get(`companies/${user.companyId}/subscriptionPlan/active`);
      setCompanyPlan(response.data);
  }, [user]);

  const getCustomersQuantity = async () => {
    try {
      const response = await api.get('/customer/config/dashboard');
      setCustomersQuantity(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const getRequestsQuantity = async () => {
    try {
      const response = await api.get('/requests/config-dashboard/quantity');
      setRequestsQuantity(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const getServiceOrdersQuantity = async () => {
    try {
      const response = await api.get('/service-order/config/dashboard');
      setServiceOrdersQuantity(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const getPurchaseOrdersQuantity = async () => {
    try {
      const response = await api.get('/purchase-order/config/dashboard');
      setPurchaseOrdersQuantity(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  const getLatestBudgets = async () => {
    try {
      const response = await api.get('/budgets/getLatestBudgets');
      setLatestBudgets(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getYearsAvailable();
    getCustomersQuantity();
    getRequestsQuantity();
    getServiceOrdersQuantity();
    getPurchaseOrdersQuantity();
    getLatestBudgets();
    getCompanyGrowth();
  }, []);

  useEffect(() => {
      getSubscriptionPlan();
  }, [getSubscriptionPlan]);

  useEffect(() => {
      if (currentCompany?.logo) {
        setLogo(`${ApiURl}/${currentCompany.logo}`)
      }
  }, [currentCompany]);

  useEffect(() => {
    getCashFlow();
    getBillingPerCustomer();
    getTotalAccounts();

    if (currentCompany?.logo) {
      setLogo(`${ApiURl}/${currentCompany.logo}`)
    }
  }, [typeShow, typeShowDashboard, monthDashboard, yearDashboard, companyDashboard, currentCompany]);

  const styleToolTip = { 
    background: "#fff", 
    border: "1px solid #ccc",
    padding: "5px",
    borderRadius: "5px",
    outline: "none"
  }

  const renderTooltipSells = (element: any) => {
    var month = monthDashboard < 10 ? "0"+ monthDashboard : monthDashboard;

    return (
      <div style={styleToolTip}>
          <b>
            {
              typeShowDashboard == "month" 
              ?
                element.label +"/"+ month +"/"+ yearDashboard
              : 
                element.label +"/"+ yearDashboard
            }
          </b>
          <hr style={{ margin: "5px" }} />
          
          {
            element.payload && element.payload.map((data: any) => {
              return (
                <p style={{ color: data.color }}><b>{data.name.charAt(0).toUpperCase() + data.name.slice(1)}:</b> {formatCurrency(data.value)}</p>
              )
            })
          }
      </div>
    )
  }

  async function getYearsAvailable() {
    var toReceive       = await api.post("/billsToReceive/config-dashboard");
    var toPay           = await api.post("/billsToPay/config-dashboard");
    var requests        = await api.get("/requests/config-dashboard");
    var serviceOrders   = await api.post("/service-order/config/dashboard");
    var pdvSales        = await api.post(`/pdvSales/config-dashboard`);

    var years: Number[] = [];
    for (var receive of toReceive.data) {
        var date = receive.dueDate.split("-");

        if (!years.includes(Number(date[0]))) {
          years.push(Number(date[0]));
        }
    }

    for (var pay of toPay.data) {
        var date = pay.dueDate.split("-");

        if (!years.includes(Number(date[0]))) {
          years.push(Number(date[0]));
        }
    }

    for (var request of requests.data) {
        var date = request.requestDate.split("-");

        if (!years.includes(Number(date[0]))) {
          years.push(Number(date[0]));
        }
    }

    for (var serviceOrder of serviceOrders.data) {
        var date = serviceOrder.date.split("-");

        if (!years.includes(Number(date[0]))) {
          years.push(Number(date[0]));
        }
    }

    for (var sale of pdvSales.data) {
        var dateSale  = new Date(sale.createdDate);
        if (!years.includes(Number(dateSale.getFullYear()))) {
          years.push(Number(dateSale.getFullYear()));
        }
    }

    years.sort(function (year1: any, year2: any) {
        return year1 - year2;
    });

    if (!years.length) {
      years.push(new Date().getFullYear());
    }

    if (!years.includes(new Date().getFullYear())) {
      years.push(new Date().getFullYear());
    }

    setYearsAvailable(years);
  }

  async function getTotalAccounts() {
    // var permissions =  JSON.parse(user.permissions);
    // if (user && menus && permissions.includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Saldo Total Por Conta")[0].id)) {
    //   var result = await getTotalBalance();
    //   setTotalAccounts(result.objects);
    // }

    var result = await getTotalBalance();
    setTotalAccounts(result.objects);
  }

  async function getCashFlow() {
    // var permissions =  JSON.parse(user.permissions);
    // if (user && menus && permissions.includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Fluxo de Caixa")[0].id)) {
    //   const accountBanks = await api.get("/accountsBank");
    //   const today = new Date();
  
    //   if (typeShowDashboard == "month") {
    //     var initialDate = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() : monthDashboard - 1)}).dateStr
    //     var finalDate   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() + 1 : monthDashboard, 0)}).dateStr
        
    //   } else {
    //     var initialDate = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 0)}).dateStr
    //     var finalDate   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 12, 0)}).dateStr
    //   }      
  
    //   var bills = await CashFlowService.getBills({
    //     accountBank: '',
    //     initialDate: initialDate.split('/').reverse().join('-'),
    //     finalDate: finalDate.split('/').reverse().join('-'),
    //     foreseen: typeShow == "foreseen" ? true : false,
    //     accomplished: typeShow == "accomplished" ? true : false,
    // });
    //   const totals = CashFlowService.getTotalAccount(bills, accountBanks.data);
  
    //   let cashFlowArr: cashFlow[] = [];
  
    //   if (typeShowDashboard === 'month') {
    //     cashFlowArr = CashFlowService.getCashFlowCompositeChartData({
    //       bills,
    //       dateType: 'month',
    //       currentYear: yearDashboard,
    //       currentMonth: monthDashboard,
    //     });
    //   } else {
    //     cashFlowArr = CashFlowService.getCashFlowCompositeChartData({
    //       bills,
    //       dateType: 'year',
    //       currentYear: yearDashboard,
    //     });
    //   }
      
    //   setCashFlow(cashFlowArr);
    //   setCashReceive(totals.totalReceive);
    //   setCashPay(totals.totalPay);
    // }

    const accountBanks = await api.get("/accountsBank");
    const today = new Date();

    if (typeShowDashboard == "month") {
      var initialDate = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() : monthDashboard - 1)}).dateStr
      var finalDate   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() + 1 : monthDashboard, 0)}).dateStr
      
    } else {
      var initialDate = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 0)}).dateStr
      var finalDate   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 12, 0)}).dateStr
    }      

    var bills = await CashFlowService.getBills({
      accountBank: '',
      initialDate: initialDate.split('/').reverse().join('-'),
      finalDate: finalDate.split('/').reverse().join('-'),
      foreseen: typeShow == "foreseen" ? true : false,
      accomplished: typeShow == "accomplished" ? true : false,
  });
    const totals = CashFlowService.getTotalAccount(bills, accountBanks.data);

    let cashFlowArr: cashFlow[] = [];

    if (typeShowDashboard === 'month') {
      cashFlowArr = CashFlowService.getCashFlowCompositeChartData({
        bills,
        dateType: 'month',
        currentYear: yearDashboard,
        currentMonth: monthDashboard,
      });
    } else {
      cashFlowArr = CashFlowService.getCashFlowCompositeChartData({
        bills,
        dateType: 'year',
        currentYear: yearDashboard,
      });
    }

    setCashFlow(cashFlowArr);
    setCashReceive(totals.totalReceive);
    setCashPay(totals.totalPay);
  }

  async function getBillingPerCustomer() {
    var customers      = await api.post(`/customer/config/dashboard${companyDashboard != "0" ? "/"+ companyDashboard : ''}`);
    var receivePaid    = await api.post("cashFlow/config-dashboard/paid/billsToReceive", {company: companyDashboard != "0" ? companyDashboard : ''});
    var partialReceive = await api.post("cashFlow/config-dashboard/billsToReceive/partial", {company: companyDashboard != "0" ? companyDashboard : ''});  

    var billingPerCustomersArr: any = [];
    for (var customer of customers.data) {
      if (customer.typeRegister == "customer") {
        var totalBilling = await calcInvoicingCustomer(customer.id, receivePaid.data, partialReceive.data);

        billingPerCustomersArr.push({
            id: customer.id,
            name: customer.typePeople == "physical" ? customer.name : customer.corporateName,
            value: totalBilling,
        });
      }
    }

    const billingSorted = billingPerCustomersArr.sort(function (customer1: any, customer2: any) {
      return customer2.value - customer1.value;
    });

    const topThreeBillings: any = billingSorted.slice(0, 3);

    setBillingPerCustomers(topThreeBillings);
    // var permissions =  JSON.parse(user.permissions);
    // if (user && menus && permissions.includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Faturamento por Cliente")[0].id)) {
    //   var customers     = await api.post(`/customer/config/dashboard${companyDashboard != "0" ? "/"+ companyDashboard : ''}`);
      
    //   var receivePaid    = await api.post("cashFlow/config-dashboard/paid/billsToReceive", {company: companyDashboard != "0" ? companyDashboard : ''});
    //   var partialReceive = await api.post("cashFlow/config-dashboard/billsToReceive/partial", {company: companyDashboard != "0" ? companyDashboard : ''});  

    //   var billingPerCustomersArr: any = [];
    //   for (var customer of customers.data) {
    //     if (customer.typeRegister == "customer") {
    //       var totalBilling = await calcInvoicingCustomer(customer.id, receivePaid.data, partialReceive.data);

    //       billingPerCustomersArr.push({
    //           id: customer.id,
    //           name: customer.typePeople == "physical" ? customer.name : customer.corporateName,
    //           value: totalBilling,
    //       });
    //     }
    //   }

    //   const billingSorted = billingPerCustomersArr.sort(function (customer1: any, customer2: any) {
    //     return customer2.value - customer1.value;
    //   });

    //   const topThreeBillings: any = billingSorted.slice(0, 3);

    //   setBillingPerCustomers(topThreeBillings);
    // }
}

  async function calcInvoicingCustomer(idCustomer: number, receivePaids: any, partialReceives: any) {
      var total        = 0;
      const today      = new Date();

      if (typeShowDashboard == "month") {
        var initialMonth = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() : monthDashboard - 1)}).dateStr;
        var finalMonth   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() + 1 : monthDashboard, 0)}).dateStr;

        var currentDayLoop = initialMonth;
        do {
          for (var receive of receivePaids) {
            if (receive.customer == idCustomer) {
              var dateReceive = receive.payedDate ? receive.payedDate.split('-').reverse() : receive.dueDate.split('-').reverse();
  
              if (dateReceive.join('/') == currentDayLoop) {
                  total += Number(receive.totalPaid ? receive.totalPaid : receive.amount);
              }
            }
          }

          for (var receivePartial of partialReceives) {
            if (receivePartial.customer == idCustomer) {
                var partials = JSON.parse(receivePartial.partialPayments);
                  
                for (var partial of partials) {
                    var dateReceive = partial.payedDate.split('-').reverse();

                    if (dateReceive.join('/') == currentDayLoop) {
                        total += Number(partial.totalPaid);
                    }
                }
            }
          }
  
          var day        = Number(currentDayLoop.split("/")[0]) + 1 < 10 ? "0" + (Number(currentDayLoop.split("/")[0]) + 1) : Number(currentDayLoop.split("/")[0]) + 1; 
          currentDayLoop = day +"/"+ currentDayLoop.split("/")[1] +"/"+ currentDayLoop.split("/")[2];
  
        } while (new Date(Number(currentDayLoop.split('/')[2]), Number(currentDayLoop.split('/')[1]) - 1, Number(currentDayLoop.split('/')[0])) <= new Date(Number(finalMonth.split('/')[2]), Number(finalMonth.split('/')[1]) - 1, Number(finalMonth.split('/')[0])));

      } else {
        var initialMonth = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 0)}).dateStr;
        var finalMonth   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 12, 0)}).dateStr;

        var currentDayLoop = initialMonth;
        do {
          for (var receive of receivePaids) {
            if (receive.customer == idCustomer) {
              var dateReceive = receive.payedDate ? receive.payedDate.split('-').reverse() : receive.dueDate.split('-').reverse();
  
              if (getNameMonth(String(dateReceive[1]), "initials") == getNameMonth(currentDayLoop.split('/')[1], "initials")) {
                  total += Number(receive.totalPaid ? receive.totalPaid : receive.amount);
              }
            }
          }

          for (var receivePartial of partialReceives) {
            if (receivePartial.customer == idCustomer) {
                var partials = JSON.parse(receivePartial.partialPayments);
                  
                for (var partial of partials) {
                    var dateReceive = partial.payedDate.split('-').reverse();

                    if (getNameMonth(String(dateReceive[1]), "initials") == getNameMonth(currentDayLoop.split('/')[1], "initials")) {
                        total += Number(partial.totalPaid);
                    }
                }
            }
          }
  
          var month      = Number(currentDayLoop.split("/")[1]) + 1 < 10 ? "0" + (Number(currentDayLoop.split("/")[1]) + 1) : Number(currentDayLoop.split("/")[1]) + 1; 
          currentDayLoop = currentDayLoop.split("/")[0] +"/"+ month +"/"+ currentDayLoop.split("/")[2];
  
        } while (new Date(Number(currentDayLoop.split('/')[2]), Number(currentDayLoop.split('/')[1]) - 1, Number(currentDayLoop.split('/')[0])) <= new Date(Number(finalMonth.split('/')[2]), Number(finalMonth.split('/')[1]) - 1, Number(finalMonth.split('/')[0])));
      }

      
      return total;
  }

  async function calcInvoicingProduct(product: any, requests: any, serviceOrders: any, saleItems: any, variations: any) {
      var total       = 0;
      const today     = new Date();      
      
      if (typeShowDashboard == "month") {
        var initialMonth = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() : monthDashboard - 1)}).dateStr;
        var finalMonth   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() + 1 : monthDashboard, 0)}).dateStr;

        var currentDayLoop = initialMonth;
        do {
          for (var request of requests) {
            var productParsed = JSON.parse(request.products);
            var dateRequest   = request.requestDate.split('-').reverse();
            
            if (dateRequest.join('/') == currentDayLoop) {
              for (var index = 0; index < productParsed.length; index++) {
                  if (productParsed[index].INSTANCE.id === product.id && productParsed[index].INSTANCE.hasVariation == "n") {
                    total += Number(productParsed[index].total);
      
                  } else if (productParsed[index].INSTANCE.hasVariation == "y") {     
                    for (var variation of variations) {
                      if (variation.productId == product.id) {
                        total += Number(productParsed[index].total);
                      }
                    }   
                  }
              }
            }
          }

          for (var serviceOrder of serviceOrders) {
            var productParsed = JSON.parse(serviceOrder.products);
            var dateServiceOrder    = serviceOrder.date.split('-').reverse();
            
            if (dateServiceOrder.join('/') == currentDayLoop) {              
                for (var indexProduct = 0; indexProduct < productParsed.length; indexProduct++) {
                  if (productParsed[indexProduct].INSTANCE.id === product.id && productParsed[indexProduct].INSTANCE.hasVariation == "n") {
                    total += Number(productParsed[indexProduct].totalValue);
      
                  } else if (productParsed[indexProduct].INSTANCE.hasVariation == "y") {        
                    for (var variation of variations) {
                      if (variation.productId == product.id) {
                        total += Number(productParsed[indexProduct].totalValue);
                      }
                    }
                  }
              }
            }
          }

          for (var item of saleItems) {
            var dateSale = item.createdDate.substring(0, 10);
            
            if (dateSale == currentDayLoop) {
              let saleValueConverted = formatIntegerToMoney(item.totalValue, false).replaceAll('.', '').replace(',', '.');
  
              if (item.productId == product.id && product.hasVariation == "n") {
                total += Number(saleValueConverted);
  
              } else if (product.hasVariation == "y") {
                for (var variation of variations) {
                  if (variation.productId == product.id) {
                    total += Number(saleValueConverted);
                  }
                }
              }
            }            
          }

          var day        = Number(currentDayLoop.split("/")[0]) + 1 < 10 ? "0" + (Number(currentDayLoop.split("/")[0]) + 1) : Number(currentDayLoop.split("/")[0]) + 1; 
          currentDayLoop = day +"/"+ currentDayLoop.split("/")[1] +"/"+ currentDayLoop.split("/")[2];
  
        } while (new Date(Number(currentDayLoop.split('/')[2]), Number(currentDayLoop.split('/')[1]) - 1, Number(currentDayLoop.split('/')[0])) <= new Date(Number(finalMonth.split('/')[2]), Number(finalMonth.split('/')[1]) - 1, Number(finalMonth.split('/')[0])));

      } else {
        var initialMonth = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 0)}).dateStr;
        var finalMonth   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 12, 0)}).dateStr;

        var currentDayLoop = initialMonth;
        do {
          for (var request of requests) {
            var productParsed = JSON.parse(request.products);
            var dateRequest   = request.requestDate.split('-').reverse();
            
            if (getNameMonth(dateRequest[1], "initials") == getNameMonth(currentDayLoop.split('/')[1], "initials")) {
              for (var index = 0; index < productParsed.length; index++) {
                  if (productParsed[index].INSTANCE.id === product.id && productParsed[index].INSTANCE.hasVariation == "n") {
                    total += Number(productParsed[index].total);
      
                  } else if (productParsed[index].INSTANCE.hasVariation == "y") {
                    for (var variation of variations) {
                      if (variation.productId == product.id) {
                        total += Number(productParsed[index].total);
                      }
                    }
                  }
              }
            }
          }

          for (var serviceOrder of serviceOrders) {
            var productParsed = JSON.parse(serviceOrder.products);
            var dateServiceOrder    = serviceOrder.date.split('-').reverse();
            
            if (getNameMonth(dateServiceOrder[1], "initials") == getNameMonth(currentDayLoop.split('/')[1], "initials")) {
                for (var index = 0; index < productParsed.length; index++) {
                  if (productParsed[index].INSTANCE.id === product.id && productParsed[index].INSTANCE.hasVariation == "n") {
                    total += Number(productParsed[index].totalValue);
      
                  } else if (productParsed[index].INSTANCE.hasVariation == "y") {        
                    for (var variation of variations) {
                      if (variation.productId == product.id) {
                        total += Number(productParsed[index].totalValue);
                      }
                    }
                  }
              }
            }
          }

          for (var item of saleItems) {
            var dateSale = item.createdDate.substring(0, 10);
            
            if (getNameMonth(dateSale[1], "initials") == getNameMonth(currentDayLoop.split('/')[1], "initials")) {
              let saleValueConverted = formatIntegerToMoney(item.totalValue, false).replaceAll('.', '').replace(',', '.');
  
              if (item.productId == product.id && product.hasVariation == "n") {
                total += Number(saleValueConverted);
  
              } else if (product.hasVariation == "y") {
                for (var variation of variations) {
                  if (variation.productId == product.id) {
                    total += Number(saleValueConverted);
                  }
                }
              }
            }            
          }
  
          var month      = Number(currentDayLoop.split("/")[1]) + 1 < 10 ? "0" + (Number(currentDayLoop.split("/")[1]) + 1) : Number(currentDayLoop.split("/")[1]) + 1; 
          currentDayLoop = currentDayLoop.split("/")[0] +"/"+ month +"/"+ currentDayLoop.split("/")[2];
  
        } while (new Date(Number(currentDayLoop.split('/')[2]), Number(currentDayLoop.split('/')[1]) - 1, Number(currentDayLoop.split('/')[0])) <= new Date(Number(finalMonth.split('/')[2]), Number(finalMonth.split('/')[1]) - 1, Number(finalMonth.split('/')[0])));
      }
      
      
      return total;
  }

  async function calcInvoicingService(service: any,serviceOrders: any) {
    var total       = 0;
    const today     = new Date();      
    
    if (typeShowDashboard == "month") {
      var initialMonth = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() : monthDashboard - 1)}).dateStr;
      var finalMonth   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, monthDashboard == 0 ? today.getMonth() + 1 : monthDashboard, 0)}).dateStr;

      var currentDayLoop = initialMonth;
      do {
        for (var serviceOrder of serviceOrders) {
          var serviceParsed = JSON.parse(serviceOrder.services);
          var dateServiceOrder    = serviceOrder.date.split('-').reverse();
          
          if (dateServiceOrder.join('/') == currentDayLoop) {              
              for (var index = 0; index < serviceParsed.length; index++) {
                if (serviceParsed[index].INSTANCE.id === service.id) {
                  total += Number(serviceParsed[index].totalValue);
                }
              }
          }
        }

        var day        = Number(currentDayLoop.split("/")[0]) + 1 < 10 ? "0" + (Number(currentDayLoop.split("/")[0]) + 1) : Number(currentDayLoop.split("/")[0]) + 1; 
        currentDayLoop = day +"/"+ currentDayLoop.split("/")[1] +"/"+ currentDayLoop.split("/")[2];

      } while (new Date(Number(currentDayLoop.split('/')[2]), Number(currentDayLoop.split('/')[1]) - 1, Number(currentDayLoop.split('/')[0])) <= new Date(Number(finalMonth.split('/')[2]), Number(finalMonth.split('/')[1]) - 1, Number(finalMonth.split('/')[0])));

    } else {
      var initialMonth = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 0)}).dateStr;
      var finalMonth   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 12, 0)}).dateStr;

      var currentDayLoop = initialMonth;
      do {
        for (var serviceOrder of serviceOrders) {
          var serviceParsed = JSON.parse(serviceOrder.services);
          var dateServiceOrder    = serviceOrder.date.split('-').reverse();
          
          if (getNameMonth(dateServiceOrder[1], "initials") == getNameMonth(currentDayLoop.split('/')[1], "initials")) {              
              for (var index = 0; index < serviceParsed.length; index++) {
                if (serviceParsed[index].INSTANCE.id === service.id) {
                  total += Number(serviceParsed[index].totalValue);
                }
              }
          }
        }

        var month      = Number(currentDayLoop.split("/")[1]) + 1 < 10 ? "0" + (Number(currentDayLoop.split("/")[1]) + 1) : Number(currentDayLoop.split("/")[1]) + 1; 
        currentDayLoop = currentDayLoop.split("/")[0] +"/"+ month +"/"+ currentDayLoop.split("/")[2];

      } while (new Date(Number(currentDayLoop.split('/')[2]), Number(currentDayLoop.split('/')[1]) - 1, Number(currentDayLoop.split('/')[0])) <= new Date(Number(finalMonth.split('/')[2]), Number(finalMonth.split('/')[1]) - 1, Number(finalMonth.split('/')[0])));
    }
    
    return total;
}

  async function getCompanyGrowth() {
    const accountBanks = await api.get("/accountsBank");
    const today = new Date();
    var initialDate = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 0)}).dateStr
    var finalDate   = getDate({ initialDate: new Date(yearDashboard == 0 ? today.getFullYear() : yearDashboard, 12, 0)}).dateStr

    var bills = await CashFlowService.getBills({
      accountBank: '',
      initialDate: initialDate.split('/').reverse().join('-'),
      finalDate: finalDate.split('/').reverse().join('-'),
      foreseen: false,
      accomplished: true,
    });

    let cashFlowArr: cashFlow[] = [];
    let companyGrowthPercentages: CompanyGrowthPercentage[] = [];

    cashFlowArr = CashFlowService.getCashFlowCompositeChartData({
      bills,
      dateType: 'year',
      currentYear: yearDashboard,
    });

    cashFlowArr.slice(1).map((cashFlow, index) => {
      const percentage = calculateGrowthPercentage(cashFlowArr[index].saldo, cashFlow.saldo);
      console.log(`mês ${cashFlow.name} porcentagem ${percentage}`);
    })

    setCompanyGrowth(cashFlowArr);
  }

  const calculateGrowthPercentage = (previous: number, current: number) => {
    const difference = current - previous;

    return difference === 0 ? Infinity : (difference / Math.abs(previous)) * 100;
  }

const handleCashFlowCompositeChartTooltipTitle = useCallback((element: any) => {
  if (typeShowDashboard === 'month') {
    return CashFlowService.getCashFlowCompositeChartTooltipTitle({
      element,
      dateType: 'month',
      currentYear: yearDashboard,
      currentMonth: monthDashboard,
    });
  } else {
    return CashFlowService.getCashFlowCompositeChartTooltipTitle({
      element,
      dateType: 'year',
      currentYear: yearDashboard,
    });
  }
}, [typeShowDashboard, yearDashboard, monthDashboard]);

  const btnSuccess = {
    color: "#fff",
    background: "green",
    border: "none"
  }

  const btnDanger = {
    color: "#fff",
    background: "red",
    border: "none"
  }

  const styleOverflow = {
    height: "360px",
    maxHeight: "360px",
    overflow: "auto"
  }

  const stylePdvOverflow = {
    height: "325px",
    maxHeight: "325px",
    overflow: "auto"
  }

  const CustomTooltipTopCustomers = ({ active, payload, label }: any) => {
      if (active && payload && payload.length) {
        return (
          <div className="styled-tooltip">
            <p className="mb-1 font-weight-bolder">{payload[0].name}</p>
            <p className="mb-1" style={{ color: "#22c55e" }}>{formatCurrency(payload[0].value)}</p>
          </div>
        )
      }

      return null;
  }

  const getBalancePerBank = (bank: string) => {
    const rowsPerPage = 4;
    const lastRowIndex = page * rowsPerPage;
    const firstRowIndex = lastRowIndex - rowsPerPage;

    if (bank === "Todos") {
      const totalPages = Math.ceil(totalAccounts.length / 4);
      const paginatedTotalAccounts = totalAccounts.slice(firstRowIndex, lastRowIndex);
      setPageCount(totalPages);
      setFilteredBanks(paginatedTotalAccounts);
      return;
    }

    const balancePerBank = totalAccounts.filter(totalAccount => totalAccount.nameBank === bank);
    const totalPages = Math.ceil(balancePerBank.length / 4);
    const paginatedBalancePerBank = balancePerBank.slice(firstRowIndex, lastRowIndex);
    const totalBalancePerBank = balancePerBank.reduce((total, account) => {
      return total + account.value;
    }, 0);

    setPageCount(totalPages);
    setFilteredBanks(paginatedBalancePerBank);
  }

  return <div ref={divRef}>
    {companyplan?.expirationDate && companyplan.daysToExpire >= 0 && companyplan.daysToExpire <= 3 && (
      <MainPageContentWrapper>
        <div className="col-lg-12 mt-3">
          <div className="alert alert-danger">Faltam {companyplan.daysToExpire} dias para o seu plano expirar! Realize o pagamento para renovar</div>
        </div>
      </MainPageContentWrapper>
    )}

    <div className="row position-relative justify-content-center m-0" style={{ background: "#F4F6FA" }}>
        <div className="col-12 p-0 mb-6 mt-3 d-flex">
          <div className="col-3">
            <div className="card dashboard-card-custom">
              <div className="p-6">
                <p className="text-dark-50 font-size-lg">Quantidade de clientes/fornecedores</p>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="font-weight-boldest" style={{ fontSize: "24px" }}>{customersQuantity ?? <Spinner animation="border" />}</span>
                  <BarChart data={fakeCustomerData} width={80} height={50} className="mr-10">
                    <Bar radius={4} dataKey="quantity" fill="#7fc6e0" />
                  </BarChart>
                </div>
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="card dashboard-card-custom">
              <div className="p-6">
                <p className="text-dark-50 font-size-lg">Quantidade de pedidos de vendas</p>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="font-weight-boldest" style={{ fontSize: "24px" }}>{requestsQuantity ?? <Spinner animation="border" />}</span>
                  <LineChart data={fakeRequestData} width={80} height={50} className="mr-10">
                    <Line dot={false} strokeWidth={4} type="monotone" dataKey="quantity" fill="#7fc6e0" stroke="#7fc6e0" />
                  </LineChart>
                </div>
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="card dashboard-card-custom">
              <div className="p-6">
                <p className="text-dark-50 font-size-lg">Quantidade de ordens de serviço</p>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="font-weight-boldest" style={{ fontSize: "24px" }}>{serviceOrdersQuantity ?? <Spinner animation="border" />}</span>
                  <AreaChart data={fakeServiceOrderData} width={80} height={50} className="mr-10">
                    <Area strokeWidth={3} type="monotone" dataKey="quantity" fill="#7fc6e0" fillOpacity={0.25} stroke="#7fc6e0" />
                  </AreaChart>
                </div>
              </div>
            </div>
          </div>
          <div className="col-3">
            <div className="card dashboard-card-custom">
              <div className="p-6">
                <p className="text-dark-50 font-size-lg">Quantidade de ordens de compra</p>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="font-weight-boldest" style={{ fontSize: "24px" }}>{purchaseOrdersQuantity ?? <Spinner animation="border" />}</span>
                  <BarChart data={fakePurchaseOrderData} width={80} height={50} className="mr-10">
                    <Bar radius={4} dataKey="quantity" fill="#7fc6e0" />
                  </BarChart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 mb-3">
          <div className="card dashboard-card-custom gutter-b">
            <div className="card-body d-flex flex-row align-items-center justify-content-between pt-3 pb-3 pr-5 pl-5">
              <div className="d-flex flex-row align-items-center">
                <b className="mr-5"><i className="flaticon2-calendar"></i>&nbsp; Data da Dashboard</b>
                <Typography component="div">
                    <Grid component="label" container alignItems="center" spacing={1}>
                      <Grid item>Mês</Grid>
                      <Grid item>
                        <AntSwitch
                          checked={typeShowDashboard == "year" ? true : false}
                          onChange={(e: any) => {
                            e.target.checked ? setTypeShowDashboard("year") : setTypeShowDashboard("month");
                            setMonthDashboard(new Date().getMonth() + 1);
                          }}
                        />
                      </Grid>
                      <Grid item>Ano</Grid>
                    </Grid>
                </Typography>
              </div>

              <div className="row col-lg-6 justify-content-end">
                {
                  typeShowDashboard == "month" 
                  ?
                    <div className="col-lg-3">
                      <TextField
                          size="small"
                          select
                          label='Mês'
                          margin='normal'
                          value={monthDashboard}
                          onChange={(e: any) => setMonthDashboard(Number(e.target.value))}
                      >
                          <MenuItem key='0' value='1'>
                              Janeiro
                          </MenuItem>

                          <MenuItem key='1' value='2'>
                              Fevereiro
                          </MenuItem>

                          <MenuItem key='2' value='3'>
                              Março
                          </MenuItem>

                          <MenuItem key='3' value='4'>
                              Abril
                          </MenuItem>

                          <MenuItem key='4' value='5'>
                              Maio
                          </MenuItem>

                          <MenuItem key='5' value='6'>
                              Junho
                          </MenuItem>

                          <MenuItem key='6' value='7'>
                              Julho
                          </MenuItem>

                          <MenuItem key='7' value='8'>
                              Agosto
                          </MenuItem>

                          <MenuItem key='8' value='9'>
                              Setembro
                          </MenuItem>

                          <MenuItem key='9' value='10'>
                              Outubro
                          </MenuItem>

                          <MenuItem key='10' value='11'>
                              Novembro
                          </MenuItem>

                          <MenuItem key='11' value='12'>
                              Dezembro
                          </MenuItem>
                      </TextField>
                    </div>
                  : <></>
                }
                                
                <div className="col-lg-3">
                  <TextField
                      size="small"
                      select
                      label='Ano'
                      margin='normal'
                      value={yearDashboard}
                      onChange={(e: any) => setYearDashboard(Number(e.target.value))}
                  >
                      {
                        yearsAvailable.map((year: any, index: number) => {
                          return (
                            <MenuItem key={index} value={year}>
                                {year}
                            </MenuItem>
                          )
                        })
                      }
                  </TextField>
                </div>

                <div className="col-lg-6">

                {
                    companyDashboard.length > 0
                    ?
                      <Autocomplete
                          options={mainAndBranches}
                          getOptionLabel={(option: any) => option.name}
                          value={mainAndBranches.find((e) => String(e.id) === companyDashboard) ?? {id: 0, name: ''}}
                          onChange={(_: any, value: any) => setCompanyDashboard(value ? String(value.id) : '')}
                          renderInput={(props: any) => (
                              <TextField
                                  { ...props }
                                  label="Empresa"
                                  margin="normal"
                                  size="small"
                              />
                          )}
                      />
                    :
                      <Autocomplete
                          options={mainAndBranches}
                          getOptionLabel={(option: any) => option.name}
                          value={mainAndBranches.find((e) => e.id === currentCompany?.id) ?? {id: 0, name: ''}}
                          onChange={(_: any, value: any) => setCompanyDashboard(value ? String(value.id) : '')}
                          renderInput={(props: any) => (
                              <TextField
                                  { ...props }
                                  label="Empresa"
                                  margin="normal"
                                  size="small"
                              />
                          )}
                      />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-3" style={{ height: "506.9px" }}>
          <div className="card dashboard-card-custom gutter-b h-100">
            <div className="my-6 d-flex flex-column align-items-center">
              <div className="rounded-circle overflow-hidden d-flex justify-content-center align-items-center"
                style={{ width: "6rem", height: "6rem",  border: "2px solid #cdcfd5" }}>
                <img
                  className="rounded-circle w-100 h-100"
                  src={logo ? logo : toAbsoluteUrl("/media/logos/header/logo-header-gold-dashboard.png")}
                  alt="Logo da empresa"
                  style={{ objectFit: "cover" }}
                />
              </div>
              <p className="font-weight-boldest font-size-h4">Empresa: { companyDashboard.length > 0 ? mainAndBranches.find((branch) => String(branch.id) === companyDashboard)?.name ?? "Não encontrada" : mainAndBranches.find((branch) => branch.id === currentCompany?.id)?.name ?? "Não encontrada" }
              </p>
              <p
                className="font-weight-boldest font-size-h5"
                style={{ color: totalBalance < 0 ? "#FF0000" : "#22C55E" }}>
                  {totalBalance ? formatCurrency(totalBalance) : <Spinner variant="dark" animation="border" />}
              </p>
            </div>

            <div className="d-flex justify-content-center" style={{ gap: "0.5rem" }}>
              <TooltipMaterialUi title={<p className="mb-0 font-size-lg">Todos os bancos</p>}>
                <button
                  className="rounded-circle other-bank-button d-flex justify-content-center align-items-center"
                  type="button"
                  onClick={() => getBalancePerBank("Todos")}>
                    <i className="fas fa-border-all text-dark"></i>
                </button>
              </TooltipMaterialUi>
              <BankButton onClick={() => getBalancePerBank("Banco do Brasil")} imageUrl="media/bank-icons/banco-do-brasil.png" tooltipTitle="Banco do Brasil" />
              <BankButton onClick={() => getBalancePerBank("Bradesco")} imageUrl="media/bank-icons/bradesco.png" tooltipTitle="Bradesco" />
              <BankButton onClick={() => getBalancePerBank("Caixa Econômica Federal")} imageUrl="media/bank-icons/caixa-economica-federal.jpg" tooltipTitle="Caixa Econômica Federal" />
              <BankButton onClick={() => getBalancePerBank("Banco Inter")} imageUrl="media/bank-icons/inter.png" tooltipTitle="Inter" />
              <BankButton onClick={() => getBalancePerBank("Itaú")} imageUrl="media/bank-icons/itau.png" tooltipTitle="Itaú" />
              <BankButton onClick={() => getBalancePerBank("Nu Pagamentos S.A.")} imageUrl="media/bank-icons/nubank.png" tooltipTitle="Nubank" />
              <BankButton onClick={() => getBalancePerBank("Santander")} imageUrl="media/bank-icons/santander.png" tooltipTitle="Santander" />
              <TooltipMaterialUi title={<p className="mb-0 font-size-lg">Outro banco</p>}>
                <button
                  className="rounded-circle other-bank-button d-flex justify-content-center align-items-center"
                  type="button"
                  onClick={() => getBalancePerBank("Outro")}>
                    <i className="fas fa-dollar-sign text-dark"></i>
                </button>
              </TooltipMaterialUi>
            </div>

            <hr />
            
            <div className="px-3 d-flex flex-column" style={{ gap: "0.5rem" }}>
              {
                filteredBanks?.map(filteredBank => (
                  <div className="p-3 rounded d-flex justify-content-between font-size-lg font-weight-bolder"
                    style={{ border: "1px solid #cdcfd5" }}>
                    <span>{filteredBank.name}</span> <span>{formatCurrency(filteredBank.value)}</span>
                  </div>
                ))
              }
            </div>

            <Pagination
              onChange={(event, page) => setPage(page)}
              count={pageCount}
              color="primary"
              variant="outlined"
              shape="rounded"
              className="px-3 d-flex justify-content-center mt-3"
            />
          </div>
        </div>

        <div className="col-6">
          <div className="card dashboard-card-custom gutter-b">
            {/* {
              user && menus && !JSON.parse(user.permissions).includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Fluxo de Caixa")[0].id) && (
                <UnauthorizedCard />
              )
            } */}
            <div className="card-body d-flex flex-column align-items-center justify-content-between flex-wrap pb-2">
              <div className="col-12 d-flex flex-column mb-3">
                <div className="mb-2">
                  <a href="/fluxo-de-caixa" className="text-dark text-uppercase font-weight-boldest" style={{ fontSize: "16px" }}>
                    Fluxo de Caixa
                  </a>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <RadioGroup
                    value={typeShow}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTypeShow(e.target.value)}
                    className={classes.radioGroup}
                    row
                  >
                    <FormControlLabel
                      value="foreseen"
                      control={<Radio className={classes.radio} />}
                      label="PREVISTO"
                      classes={{ label: `${classes.label} ${typeShow === "foreseen" && classes.selectedLabel}` }}
                    />
                    <FormControlLabel
                      value="accomplished"
                      control={<Radio className={classes.radio} />}
                      label="REALIZADO"
                      classes={{ label: `${classes.label} ${typeShow === "accomplished" && classes.selectedLabel}` }}
                    />
                  </RadioGroup>

                  <RadioGroup
                    value={typeShowDashboard}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      setTypeShowDashboard(e.target.value);
                      setMonthDashboard(new Date().getMonth() + 1);
                    }}
                    className={classes.radioGroup}
                    row
                  >
                    <FormControlLabel
                      value="month"
                      control={<Radio className={classes.radio} />}
                      label="MÊS"
                      classes={{ label: `${classes.label} ${typeShowDashboard === "month" && classes.selectedLabel}` }}
                    />
                    <FormControlLabel
                      value="year"
                      control={<Radio className={classes.radio} />}
                      label="ANO"
                      classes={{ label: `${classes.label} ${typeShowDashboard === "year" && classes.selectedLabel}` }}
                    />
                  </RadioGroup>
                </div>
              </div>
              <CashFlowComposedChart
                cashFlow={cashFlow}
                cashReceive={cashReceive}
                cashPay={cashPay}
                tooltipTitleHandler={handleCashFlowCompositeChartTooltipTitle}
              />
            </div>
          </div>
        </div>

        <div className="col-3">
          <div className="card dashboard-card-custom gutter-b bg-primary">
            <div className="card-body d-flex flex-column align-items-center justify-content-between flex-wrap">
              <p className="text-dark text-uppercase font-weight-boldest w-100" style={{ fontSize: "16px" }}>Crescimento da empresa</p>

              <LineChart width={200} height={200} data={companyGrowth}>
                <Line dot={false} type="monotone" dataKey="saldo" stroke="#181C32" strokeWidth={3} />
                <Tooltip />
              </LineChart>
            </div>
          </div>
          <div className="card dashboard-card-custom gutter-b">
              {/* {
                user && menus && !JSON.parse(user.permissions).includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Faturamento por Cliente")[0].id) && (
                  <UnauthorizedCard />
                )
              } */}
                <div className="card-body d-flex flex-column align-items-center justify-content-between flex-wrap">
                  <div className="w-100 mb-7">
                    <p className="text-uppercase font-weight-boldest mb-0" style={{ fontSize: "16px" }}>Últimos Orçamentos</p>
                  </div>

                  <div className="d-flex w-100 mb-3" style={{ fontSize: "14px", color: "#6B7280" }}>
                    <div className="col-4">
                      <b>Cliente</b>
                    </div>
                    <div className="col-4">
                      <b>Valor</b>
                    </div>
                    <div className="col-4">
                      <b>Data</b>
                    </div>
                  </div>

                  {
                    latestBudgets?.length
                    ?
                      <div className="col-12 d-flex flex-column p-0" style={styleOverflow}>
                        {
                          latestBudgets.map((latestBudget, index) => {
                            return (
                              <div key={latestBudget.id} className="d-flex flex-row align-items-center justify-content-between mb-3">
                                <TooltipMaterialUi title={<p className="mb-0 font-size-lg">{latestBudget.customer ?? "Não informado"}</p>}>
                                  <div className="col-4 text-truncate">
                                    <b className="font-size-lg">{latestBudget.customer ?? "Não informado"}</b>
                                  </div>
                                </TooltipMaterialUi>

                                <TooltipMaterialUi title={<p className="mb-0 font-size-lg">{formatCurrency(latestBudget.totalValue)}</p>}>
                                  <div className="col-4 text-truncate">
                                    <b className="mr-3 font-size-lg" style={{ color: "#22c55e" }}>{formatCurrency(latestBudget.totalValue)}</b>
                                  </div>
                                </TooltipMaterialUi>

                                <TooltipMaterialUi title={<p className="mb-0 font-size-lg">{formatDate(latestBudget.date)}</p>}>
                                  <div className="col-4 text-truncate">
                                    <b className="font-size-lg">{formatDate(latestBudget.date)}</b>
                                  </div>
                                </TooltipMaterialUi>
                              </div>
                            )
                          })
                        }
                      </div>
                    :
                      <div className="col-12 d-flex flex-column" style={styleOverflow}>
                        <p style={{color: "#ccc"}}>Nenhum orçamento até o momento...</p>
                      </div>
                  }
                </div>
          </div>
        </div>

        <div className="col-9">
          {/* {
            user && menus && !JSON.parse(user.permissions).includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Calendário de Lançamentos e Eventos")[0].id) && (
              <UnauthorizedCard />
            )
          } */}
          <div className="card dashboard-card-custom gutter-b py-5">
            <Calendar
              company={companyDashboard}
              currentCompanyId={currentCompany?.id}
              showMonth={typeShowDashboard == "month" ? "actual" : "all"}
              month={monthDashboard}
              year={yearDashboard}
              dateSelected={dateSelected}
              setDateSelected={setDateSelected}
              setMonth={setMonthDashboard}
              setYear={setYearDashboard}
              divRef={divRef}
            />
          </div>
        </div>

        <div className="col-3">
          <div className="card dashboard-card-custom gutter-b">
            {/* {
              user && menus && !JSON.parse(user.permissions).includes(menus.filter(menu => menu.name == "Dashboard")[0]?.submenus?.filter(submenu => submenu.name == "Faturamento por Cliente")[0].id) && (
                <UnauthorizedCard />
              )
            } */}
            <div className="card-body d-flex flex-column align-items-center justify-content-between flex-wrap">
              <div className="d-flex w-100 flex-row align-items-center justify-content-between mb-7">
                  <p className="text-uppercase font-weight-boldest mb-0" style={{ fontSize: "16px" }}>Top 3 Clientes - Faturamento</p>
              </div>

              {
                billingPerCustomers.every(billingPerCustomer => billingPerCustomer.value === 0)
                ?
                    (
                      <div className="font-weight-bolder font-size-lg mb-7">
                        Não há gráfico disponível!
                      </div>
                    )
                  :
                    (
                      <PieChart width={200} height={200}>
                        <Pie
                          data={billingPerCustomers}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={80}
                          fill="#8884d8"
                          dataKey="value"
                        >
                          {billingPerCustomers.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={medalColor[index]} />
                          ))}
                        </Pie>
                        <Tooltip content={<CustomTooltipTopCustomers />}/>
                      </PieChart>
                    )
              }

              <div className="d-flex w-100 mb-3" style={{ fontSize: "14px", color: "#6B7280" }}>
                <div className="col-7">
                  <b>Cliente</b>
                </div>
                <div className="col-5">
                  <b>Valor</b>
                </div>
              </div>

              {
                billingPerCustomers.length
                ?
                <div className="col-12 d-flex flex-column p-0" style={styleOverflow}>
                  {
                    billingPerCustomers.map((customer, index) => {
                      let total = 0;
                      
                      for(const i of billingPerCustomers){
                        total += i.value;
                      };

                      return (
                        <div key={customer.id} className="d-flex flex-row align-items-center justify-content-between mb-3">
                          <div className="col-7 d-flex align-items-center">
                            <div className="mr-2 rounded-circle" style={{ width: "15px", height: "15px", backgroundColor: medalColor[index] }}></div>
                            <TooltipMaterialUi title={<p className="mb-0 font-size-lg">{customer.name}</p>}>
                              <b className="font-size-lg text-truncate">{customer.name}</b>
                            </TooltipMaterialUi>
                          </div>

                          <div className="col-5 text-truncate">
                            <TooltipMaterialUi title={<p className="mb-0 font-size-lg">{formatCurrency(customer.value)}</p>}>
                              <b className="mr-3 font-size-lg" style={{ color: "#22c55e" }}>{formatCurrency(customer.value)}</b>
                            </TooltipMaterialUi>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                :
                <div className="col-12 d-flex flex-column" style={styleOverflow}>
                  <p style={{color: "#ccc"}}>Nenhum faturamento por cliente até o momento...</p>
                </div>
              }
            </div>
          </div>
        </div>
    </div>
  </div>;
}
